__turbopack_context__.v({
  "accordion": "DesktopCardView-module-scss-module__Hzip_q__accordion",
  "breadcrumbs": "DesktopCardView-module-scss-module__Hzip_q__breadcrumbs",
  "header": "DesktopCardView-module-scss-module__Hzip_q__header",
  "installationDock": "DesktopCardView-module-scss-module__Hzip_q__installationDock",
  "installationDockBar": "DesktopCardView-module-scss-module__Hzip_q__installationDockBar",
  "installationDockChevron": "DesktopCardView-module-scss-module__Hzip_q__installationDockChevron",
  "installationDockIcon": "DesktopCardView-module-scss-module__Hzip_q__installationDockIcon",
  "installationDockLabel": "DesktopCardView-module-scss-module__Hzip_q__installationDockLabel",
  "installationDockScroll": "DesktopCardView-module-scss-module__Hzip_q__installationDockScroll",
  "installationDockSelect": "DesktopCardView-module-scss-module__Hzip_q__installationDockSelect",
  "installationInFlow": "DesktopCardView-module-scss-module__Hzip_q__installationInFlow",
  "list": "DesktopCardView-module-scss-module__Hzip_q__list",
});
